// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"dfb4fe7e","787":"45334408","850":"3d166336"}[chunkId] + ".chunk.js";
};